import { render, staticRenderFns } from "./learn2.vue?vue&type=template&id=1b7976a2&scoped=true"
import script from "./learn2.vue?vue&type=script&lang=js"
export * from "./learn2.vue?vue&type=script&lang=js"
import style0 from "./learn2.vue?vue&type=style&index=0&id=1b7976a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b7976a2",
  null
  
)

export default component.exports